import { useEffect, useState } from "react";
import { readReadingLevels, type ReadingLevels } from "../../../shared/reading-levels";
import { useReadingApi } from "./api";
import { TopicForm, type TopicFormProps } from "./TopicForm";

export function SavedTopicForm(props: TopicFormProps) {
  const { fetch } = useReadingApi();
  const [levels, setLevels] = useState<ReadingLevels>();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setError("");
    void fetch("/api/levels", { signal: controller.signal })
      .then(async response => {
        if (!response.ok) throw new Error("load_failed");
        const data = readReadingLevels(await response.json());
        if (!controller.signal.aborted) setLevels(data);
      })
      .catch(() => { if (!controller.signal.aborted) setError("לא הצלחנו לטעון את רמות הקריאה."); });
    return () => controller.abort();
  }, [fetch, attempt]);

  return <>
    <TopicForm {...props} initialLevels={levels} levelsLoading={!levels} busy={props.busy || saving || !levels}
      onLevelChange={async (language, preset) => {
        setSaving(true);
        setError("");
        try {
          const response = await fetch("/api/level", {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ language, preset }),
          });
          if (!response.ok) throw new Error("save_failed");
          return true;
        } catch {
          setError("לא הצלחנו לשמור את רמת הקריאה. כדאי לנסות שוב.");
          return false;
        } finally { setSaving(false); }
      }} />
    {!levels && error && <button onClick={() => setAttempt(value => value + 1)}>ניסיון נוסף</button>}
    {error && <div className="error" role="alert">{error}</div>}
  </>;
}
